import {
  BreadcrumbItem as ChakraBreadcrumbItem,
  BreadcrumbItemProps as ChakraBreadcrumbItemProps,
  forwardRef,
} from '@chakra-ui/react';
import React, { Children, cloneElement, isValidElement } from 'react';

import { OmitChakraProps } from '../../utils/typeUtils';
import { BreadcrumbLink } from '../BreadcrumbLink/BreadcrumbLink';

export interface BreadcrumbItemProps
  extends OmitChakraProps<ChakraBreadcrumbItemProps> {
  isDisabled?: boolean;
}

export const BreadcrumbItem = forwardRef<BreadcrumbItemProps, 'li'>(
  ({ children, isCurrentPage, isDisabled, ...props }, ref) => {
    const validChildren = Children.toArray(children).filter((child) =>
      isValidElement(child),
    ) as React.ReactElement[];

    const clones = validChildren.map((child) => {
      if (child.type === BreadcrumbLink) {
        return cloneElement(child, { isCurrentPage, isDisabled });
      }

      return child;
    });

    return (
      <ChakraBreadcrumbItem ref={ref} {...props}>
        {clones}
      </ChakraBreadcrumbItem>
    );
  },
);
